<template lang="pug">
.oembed-section(
  :tabindex="canEdit ? 0 : false"
  :class="oembedTypeClass",
)
  .oembed__wrapper
    .oembed__header
      a.oembed-provider(
        :href="link"
        target="_blank"
      )
        .oembed-provider__icon(
          :style="`background-image: url(${providerFavicon})`"
        )
        .oembed-provider__name {{ providerName }}

      .remove-oembed-button.btn.--link(
        v-if="canRemove"
        @click="$emit('remove')"
      ) Remove
    .oembed__embed-wrapper
      .oembed__embed(
        :style="embedStyles"
        ref="embed"
        v-html="embedContent"
      )
      .embed__overlay(v-if="blockInteraction")
    .oembed__footer
      .oembed-title {{ title }}
      .oembed-author {{ authorName }}
</template>

<script>
export default {
  name: 'oembed-section',
  props: {
    oembed: {
      type: Object,
      default: null,
    },
    canRemove: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    blockInteraction: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    oembed(val) {
      if (!val) return
      if (this.type === 'video') {
        this.$nextTick(() => {
          const iframe = this.$refs.embed.querySelector('iframe')
          iframe.setAttribute('tabindex', -1)
        })
      }
    },
  },
  computed: {
    title() {
      return this.oembed ? this.oembed.title : ''
    },
    type() {
      return this.oembed && this.oembed.type ? this.oembed.type : 'link'
    },
    link() {
      return this.oembed && this.oembed.url ? this.oembed.url : null
    },
    authorName() {
      return this.oembed ? this.oembed.author_name : ''
    },
    oembedTypeClass() {
      const typeClassMap = {
        photo: '--photo',
        video: '--video',
        rich: '--rich',
        link: '--link', // default
      }
      return typeClassMap[this.type]
    },
    embedStyles() {
      const width = this.oembed ? this.oembed.width : '0px'
      const height = this.oembed ? this.oembed.height : '0px'
      return {
        paddingBottom: `calc((${height} / ${width}) * 100%`,
      }
    },
    embedContent() {
      return this.oembed ? this.oembed.html : ''
    },
    providerName() {
      return this.oembed ? this.oembed.provider_name : ''
    },
    providerFavicon() {
      return this.oembed ? `${this.oembed.provider_url}/favicon.ico` : ''
    },
  },
}
</script>

<style lang="sass">
.oembed-section
  position: relative
  display: flex
  justify-content: center
  margin-bottom: 1rem
  
  &.--video,
  &.--photo
    .oembed__embed-wrapper
      display: flex
      justify-content: center
      background-color: black

.oembed__wrapper
  width: 100%

.oembed__header,
.oembed__footer
  padding: .5rem .75rem 
  display: flex
  align-items: center // vertical alignment
  justify-content: space-between

.oembed-title
  font-family: var(--sans-serif-fonts)
  font-size: 1em

.oembed__embed-wrapper
  position: relative
  display: flex
  justify-content: center

.oembed__embed
  position: relative
  width: 100%
  iframe 
    position: absolute
    width: 100%;
    height: 100%;
    object-fit: cover

.embed__overlay
  position: absolute
  top: 0px
  left: 0px
  bottom: 0px
  right: 0px

.oembed-provider
  display: inline-flex
  align-items: center

.oembed-provider__icon,
.oembed-provider__name
  display: inline-block

.oembed-provider__icon
  width: 16px
  height: 16px
  margin-right: .5rem

</style>
